import { render, staticRenderFns } from "./bancos.vue?vue&type=template&id=2ccb37a4"
import script from "./bancos.vue?vue&type=script&lang=js"
export * from "./bancos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports